import { ToastService } from './../../providers/util/toast.service';
import { LoadingController } from 'ionic-angular';
import { BtBackendProvider } from './../../providers/bt-backend/bt-backend';
import 'rxjs/add/operator/first';
import { Component, Input, ViewChild, ElementRef, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
declare var stripe: any;
declare var stripeElements: any;

@Component({
  selector: 'user-subscription-stripe',
  templateUrl: 'user-subscription-stripe.html'
})
export class UserSubscriptionStripeComponent {

  @ViewChild('cardInfo') cardInfo: ElementRef;
  @Input('price') price: string;
  @Input('plan') plan: string;
  @Output('processed') processed = new EventEmitter<boolean>(); //True for card

  card: any;
  cardHandler = this.onChange.bind(this);
  error: string;

  constructor(
    private cd: ChangeDetectorRef,
    private backend: BtBackendProvider,
    private loadingCtrl: LoadingController,
    private toast: ToastService
  ) {

  }

  ngOnInit(){
    const style = {
      base: {
        lineHeight: '24px',
        fontSmoothing: 'antialiased',
        color: '#ffffff',
        '::placeholder': {
          color: '#cecece'
        }
      }
    };

    this.card = stripeElements.create('card', { style });
    this.card.mount(this.cardInfo.nativeElement);
    this.card.addEventListener('change', this.cardHandler);
  }

  ngOnDestroy(){
    this.card.addEventListener('change', this.cardHandler);
    this.card.destroy();
  }

  onChange({ error }) {
    if (error) {
      this.error = error.message;
    } else {
      this.error = null;
    }
    this.cd.detectChanges();
  }

  onSubmit(form){
    let loader = this.loadingCtrl.create();
    loader.present();
    stripe.createToken(this.card)
      .then(result => {
        if(result.error){
          // this.toastCtrl.create(result.error.message);
          loader.dismiss();
        }else{
          if(this.plan && result.token.id){
            this.backend.setStripeCreditCard(result.token.id, this.plan)
              .first()
              .subscribe(res => {
                loader.dismiss();
                this.processed.emit(true);

                // this.viewCtrl.dismiss();
              }, error =>{
                if(error.error.message){
                  this.toast.create(error.error.message, true, 3000);
                }
                loader.dismiss();
              })
          }else{
            loader.dismiss();

            // this.toastCtrl.create("need to fill out form");
          }
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/components/user-subscription-stripe/user-subscription-stripe.ts